export default __webpack_public_path__ + "static/media/park.0debb83f.svg";